import { bl_fi_my_einvoice_from_irb_run_hdr_RowClass } from '../../dbschema/bl_fi_my_einvoice_from_irb_run_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class FromIRBRunContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_from_irb_run_hdr: bl_fi_my_einvoice_from_irb_run_hdr_RowClass = new bl_fi_my_einvoice_from_irb_run_hdr_RowClass();
}
